export default __webpack_public_path__ + "static/yellow_gift-3e258bbe5d55d643e6c8ac3c816dd511.png";